import { render, staticRenderFns } from "./nuestrotrabajo.vue?vue&type=template&id=52d1089a"
import script from "./nuestrotrabajo.vue?vue&type=script&lang=js"
export * from "./nuestrotrabajo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports